import { Component, OnInit } from "@angular/core";
import {
    NgbModalConfig,
    NgbModal,
    NgbModalOptions,
    ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import {
    Router,
    ActivatedRoute,
    NavigationEnd,
    NavigationStart,
} from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";

import { InvoiceService } from "./../../../_services/invoice.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";

@Component({
    selector: "app-upload-preview-logistics",
    templateUrl: "./upload-preview-logistics.component.html",
    styleUrls: ["./upload-preview-logistics.component.scss"],
})
export class UploadPreviewLogisticsComponent
    implements OnInit, DirtyCheckComponent
{
    docs = [
        {
            docType: "PO2S",
            description: "PO2S",
        },
        {
            docType: "PO2X",
            description: "PO2X",
        },
        {
            docType: "PO2O",
            description: "PO2O",
        },
    ];

    invoiceDetails: any;
    closeResult: string = "";
    modalOptions: NgbModalOptions;
    loading: boolean = false;
    uploadSuccessful: boolean = false;
    saving: boolean = false;
    uploadInvoice: boolean = false;
    displayName: any;
    hasError: boolean = false;
    imgUrl: string = "";
    typeError: boolean = false;
    sizeError: boolean = false;
    fileTypeError: boolean = false;
    fileSizeError: boolean = false;
    invoiceSaved: boolean = false;
    savingError: boolean = false;
    validationError: boolean = false;
    serverError: boolean = false;
    supportingDocuments: any[] = [];
    agreed = [{ status: false }];
    masterData: any;
    responseData: any;
    isError = false;
    vendorData: any;
    pdfSrc: any;
    invoiceFile: any;
    invoiceDataToSave: any;
    isInvoiceChange: boolean = false;
    isUpdatedData: boolean = false;
    invoiceChanged: boolean = false;
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    barcodeNo: any;
    eLoaderMsg = "";
    formSubmitted = false;
    previousUrl: any;
    companies: any;
    organisations: any;
    configResCompanies: any;
    configResOrg: any;
    totalSizeError = false;
    files: File[];
    supportingDocsAdded = false;
    canSubmitForm = false;
    allDeleted = false;
    isShippingInvoice = false;
    vesselError = false;
    isSubmittingInvoice: boolean = false;

    extractedInvoiceLogistics = new FormGroup({
        invoiceType: new FormControl("e-invoice"),
        file: new FormControl(null),
        supportingFiles: new FormControl([]),
        fileSource: new FormControl(""),
        documentSource: new FormControl(""),
        terms_agreed: new FormControl(false),
        emailAddress: new FormControl(null, [
            Validators.email,
            Validators.pattern(
                "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
            ),
        ]),
        poNumber: new FormControl(null, [
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(10),
            Validators.maxLength(10),
        ]),
        username: new FormControl(""),
        userID: new FormControl(""),
        companyCode: new FormControl(null, [Validators.required]),
        purchaseOrg: new FormControl(null, [Validators.required]),
        docType: new FormControl(null, [Validators.required]),
        vesselNumber: new FormControl("", [Validators.required]),
        vesselName: new FormControl("", [Validators.required]),
    });

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private invoiceService: InvoiceService
    ) {
        this.modalOptions = {
            backdrop: "static",
            backdropClass: "customBackdrop",
            scrollable: true,
        };

        this.router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                this.previousUrl = val.url;
            }
        });
    }

    canDeactivate() {
        if (!this.formSubmitted) {
            this.loading = true;
            return false;
        } else {
            return true;
        }
    }

    exitForm() {
        this.loading = false;
        this.formSubmitted = true;
        this.previousUrl =
            this.route.snapshot.queryParams["returnUrl"] || "dashboard";
        //const returnUrl = this.route.snapshot.queryParamMap["returnUrl"];
        console.log(this.previousUrl);
        this.router.navigateByUrl(this.previousUrl);
    }

    cancelExit() {
        this.loading = false;
    }

    toggleSidebar() {
        this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
        document.body.setAttribute(
            "data-sidebar-size",
            this.currentLayout.isCondensed ? "condensed" : "default"
        );
    }

    selectDocuments(event: any) {
        const MAX_FILE_SIZE = 25 * 1024 * 1024; // 5MB
        const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 25MB
        const ALLOWED_TYPES = ["application/pdf"];

        this.files = Array.from(event);
        // Calculate the total size of the selected files (in bytes)
        const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

        // Check if the total size exceeds 25 MB
        if (totalSize > MAX_TOTAL_SIZE) {
            this.totalSizeError = true;
            this.sizeError = false;
            this.typeError = false;
        }

        for (const file of this.files) {
            // Check if any individual file size exceeds 5 MB
            if (file.size > MAX_FILE_SIZE) {
                this.sizeError = true;
                this.typeError = false;
                this.totalSizeError = false;
                continue;
            }

            // Filter out any files that are not Word, Excel, or PDF
            if (!ALLOWED_TYPES.includes(file.type)) {
                this.typeError = true;
                this.sizeError = false;
                this.totalSizeError = false;
                continue;
            }
            this.supportingDocuments.push(file);
        }

        if (this.allDeleted === true) {
            if (
                this.extractedInvoiceLogistics.get("terms_agreed").value ===
                true
            ) {
                this.extractedInvoiceLogistics.patchValue({
                    terms_agreed: false,
                });
            }
        } else {
            this.extractedInvoiceLogistics.patchValue({ terms_agreed: false });
        }

        this.supportingDocsAdded = true;
    }

    /**
     * Delete file from files list
     * @param index (File index)
     */
    deleteFile(index: number) {
        this.supportingDocuments.splice(index, 1);

        if (this.supportingDocuments.length === 0) {
            if (
                this.extractedInvoiceLogistics.get("terms_agreed").value ===
                true
            ) {
                this.extractedInvoiceLogistics.patchValue({
                    terms_agreed: false,
                });
            }

            this.canSubmitForm = false;
            this.allDeleted = true;
            this.supportingDocsAdded = false;
        }
    }

    checkSupportingDocuments() {
        if (
            this.supportingDocuments.length > 0 &&
            this.extractedInvoiceLogistics.get("terms_agreed").value === false
        ) {
            this.canSubmitForm = true;
        } else {
            this.canSubmitForm = false;
        }
    }

    onDrop(event: any) {
        // Update the list order
        moveItemInArray(
            this.supportingDocuments,
            event.previousIndex,
            event.currentIndex
        );
        this.supportingDocsAdded = true;
    }

    reUploadInvoice(event: any) {
        if (event.length > 0) {
            const fileUploaded = event[0];

            //console.log(fileUploaded);

            if (fileUploaded.type !== "application/pdf") {
                this.hasError = false;
                this.fileSizeError = false;
                this.fileTypeError = true;
            } else if (fileUploaded.size > 100 * 1024 * 1024) {
                this.fileTypeError = false;
                this.hasError = false;
                this.fileSizeError = true;
            } else {
                this.fileSizeError = false;
                this.fileTypeError = false;

                if (typeof FileReader !== "undefined") {
                    let reader = new FileReader();
                    reader.onload = (e: any) => {
                        this.pdfSrc = e.target.result;
                        //console.log(this.pdfSrc);
                    };
                    let $file: any = fileUploaded;
                    reader.readAsArrayBuffer($file);
                }

                this.extractedInvoiceLogistics.patchValue({
                    fileSource: fileUploaded,
                });

                this.hasError = false;
                this.isInvoiceChange = true;

                let userId = this.invoiceService.getUserId();
                let username = this.invoiceService.getUsername();

                const userData = {
                    req: {
                        emailAddress:
                            this.extractedInvoiceLogistics.value.emailAddress,
                        companyCode:
                            this.extractedInvoiceLogistics.value.companyCode,
                        purchaseOrg:
                            this.extractedInvoiceLogistics.value.purchaseOrg,
                        docType: this.extractedInvoiceLogistics.value.docType,
                        poNumber: this.extractedInvoiceLogistics.value.poNumber,
                        username: username,
                        userId: userId,
                        items: [{ poNumber: "", itemNo: "", grn: "" }],
                    },
                };

                this.loading = true;
                this.invoiceChanged = true;
                this.formSubmitted = true;

                const formData: any = new FormData();
                // formData.append('poNumber', this.route.snapshot.params['poNo']);
                formData.append(
                    "sellerCode",
                    localStorage.getItem("vendorCode")
                );
                formData.append(
                    "sessionId",
                    localStorage.getItem("userSession")
                );
                formData.append("invoiceType", "e-invoice");
                formData.append("req", JSON.stringify(userData.req));
                formData.append(
                    "file",
                    this.extractedInvoiceLogistics.value.fileSource
                );

                this.eLoaderMsg = "Verifying QR Code";

                setTimeout(() => {
                    this.eLoaderMsg = "Authenticating QR Code";
                }, 5000);
                setTimeout(() => {
                    this.eLoaderMsg = "Extracting Data";
                }, 10000);
                setTimeout(() => {
                    this.eLoaderMsg = "Validating Data";
                }, 15000);

                this.invoiceService.extractInvoice(formData).subscribe(
                    (res) => {
                        this.loading = false;
                        this.invoiceChanged = false;
                        this.isUpdatedData = true;
                        this.responseData = res;
                        this.formSubmitted = false;
                        //console.log(res);
                        if (
                            this.responseData.length !== 0 &&
                            this.responseData.status === "error"
                        ) {
                            console.log(this.responseData.message);
                        } else {
                            //console.log("Success hereresponseData");
                            this.invoiceDetails = this.responseData;
                        }
                    },
                    (error) => {
                        console.log(error.msg);
                    }
                );
            }
        }
    }

    open(content: any) {
        this.modalService.open(content, this.modalOptions).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    saveUploadData() {
        this.loading = true;
        this.saving = true;
        //this.uploadInvoice = false;

        const invoiceData = {
            sellerCode: localStorage.getItem("vendorCode"),
            session: { sessionId: localStorage.getItem("userSession") },
            data: {
                irn: this.invoiceDetails.irn,
                invoice_number: this.invoiceDetails.invoice_number,
                file_link: this.invoiceDetails.file_link,
                gstin: this.invoiceDetails.gstin,
                invoice_date: this.invoiceDetails.invoice_date,
                invoice_amount: this.invoiceDetails.invoice_amount,
                terms_agreed: false,
                errors: [],
                supporting_docs: this.invoiceDetails.supporting_docs,
                emailAddress: this.extractedInvoiceLogistics.value.emailAddress,
                poNumber: this.extractedInvoiceLogistics.value.poNumber,
                companyCode: this.extractedInvoiceLogistics.value.companyCode,
                purchaseOrg: this.extractedInvoiceLogistics.value.purchaseOrg,
                docType: this.extractedInvoiceLogistics.value.docType,
                items: this.invoiceDetails.items,
            },
        };

        this.invoiceService.uploadInvoice(invoiceData).subscribe(
            (res) => {
                this.responseData = res;
                if (this.responseData.status == "successful") {
                    this.saving = false;
                    this.uploadInvoice = false;
                    this.uploadSuccessful = false;
                    this.savingError = false;
                    this.serverError = false;
                    this.hasError = false;
                    this.invoiceSaved = true;
                } else {
                    this.saving = false;
                    this.invoiceSaved = false;
                    this.uploadInvoice = false;
                    this.uploadSuccessful = false;
                    this.hasError = false;
                    this.serverError = false;
                    this.savingError = true;
                }

                //console.log(res);
            },
            (error) => {
                this.saving = false;
                this.invoiceSaved = false;
                this.uploadInvoice = false;
                this.uploadSuccessful = false;
                this.serverError = false;
                this.savingError = true;
                //console.log(error);
            }
        );
    }

    onSubmit() {
        if (this.isSubmittingInvoice) {
            return;
        }

        this.loading = true;

        if (
            this.extractedInvoiceLogistics.value.vesselNumber !== "" &&
            this.extractedInvoiceLogistics.value.vesselName !== ""
        ) {
            this.isSubmittingInvoice = true;
            this.uploadInvoice = true;
            this.formSubmitted = true;
            this.vesselError = false;
            this.hasError = false;
            let userName = this.invoiceService.getUsername();
            let userID = this.invoiceService.getUserId();
            const userData = {
                companyCode: this.invoiceDetails.company_code,
                purchaseOrg: this.invoiceDetails.purchase_org,
                docType: this.invoiceDetails.doc_type,
                emailAddress: this.invoiceDetails.email_address,
                poNumber: this.extractedInvoiceLogistics.value.poNumber,
                username: userName,
                userId: userID,
                items: [{ poNumber: "", itemNo: "", grn: "" }],
                vesselNumber:
                    this.extractedInvoiceLogistics.value.vesselNumber.toUpperCase(),
                vesselName:
                    this.extractedInvoiceLogistics.value.vesselName.toUpperCase(),
                termsAgreed: true,
            };

            if (this.isInvoiceChange === true) {
                this.invoiceFile =
                    this.extractedInvoiceLogistics.value.fileSource;
            } else {
                this.invoiceFile = this.invoiceService.getFileElement();
            }

            const trimNo = this.invoiceDetails.invoice_number.replace(
                /\s+/g,
                ""
            );

            const mapKeys = {
                file_link: this.invoiceDetails.file_link,
                SellerGstin: this.invoiceDetails.gstin,
                BuyerGstin: "",
                DocNo: trimNo,
                DocTyp: "INV",
                DocDt: this.invoiceDetails.invoice_date,
                TotInvVal: this.invoiceDetails.invoice_amount,
                ItemCnt: "",
                MainHsnCode: "",
                Irn: this.invoiceDetails.irn,
                IrnDt: "",
                invType: this.invoiceService.getInvType(),
                invoiceType: this.invoiceService.getInvoiceType(),
            };

            const fileOrder = [];
            this.supportingDocuments.forEach((file, index) => {
                const obj = {};
                obj[(index + 1).toString()] = file.name;
                fileOrder.push(obj);
            });

            //console.log(localStorage.getItem("userSession"));

            const formData: any = new FormData();
            formData.append("sellerCode", localStorage.getItem("vendorCode"));
            formData.append("sessionId", localStorage.getItem("userSession"));
            formData.append("invType", this.invoiceService.getInvType());
            formData.append("fileOrder", JSON.stringify(fileOrder));
            formData.append("req", JSON.stringify(userData));
            formData.append("data", JSON.stringify(mapKeys));

            if (this.supportingDocuments.length !== 0) {
                for (let i = 0; i < this.supportingDocuments.length; i++) {
                    formData.append(
                        "supportingDocs",
                        this.supportingDocuments[i]
                    );
                }
            } else {
                formData.append("supportingDocs", this.supportingDocuments);
            }

            if (!this.saving) {
                this.invoiceService
                    .uploadInvoiceWithoutExtration(formData)
                    .subscribe(
                        (res) => {
                            this.isSubmittingInvoice = false;
                            this.responseData = res;
                            //console.log(this.responseData.status);

                            if (this.responseData.status === "error") {
                                console.log("error exist");
                                this.loading = false;
                                this.uploadInvoice = false;
                                this.hasError = true;
                                this.formSubmitted = false;
                            } else {
                                this.barcodeNo = this.responseData.barcode;
                                const data = {
                                    barcode: this.barcodeNo,
                                    docTyp: "INV",
                                    sellerCode:
                                        localStorage.getItem("vendorCode"),
                                    session: {
                                        sessionId:
                                            localStorage.getItem("userSession"),
                                    },
                                };
                                //console.log(data);

                                if (userData.docType !== "PO2S") {
                                    
                                    // this.invoiceService
                                    //     .sendInvoiceToJSW(data)
                                    //     .subscribe(
                                    //         (res) => {
                                    //             console.log(res);
                                    //         },
                                    //         (error) => {
                                    //             this.hasError = true;
                                    //             this.responseData = {
                                    //                 message:
                                    //                     error?.msg ||
                                    //                     error?.message ||
                                    //                     "Unable to process the request. Please try again.",
                                    //                 status: "error"
                                    //             };
                                    //         }
                                    //     );
                                }

                                console.log("Success");

                                this.uploadSuccessful = true;
                                this.uploadInvoice = false;
                            }
                        },
                        (error) => {
                            this.isSubmittingInvoice = false;
                            this.uploadInvoice = false;
                            this.uploadSuccessful = false;
                            this.invoiceSaved = false;
                            this.serverError = true;
                            this.hasError = true;
                            this.responseData = {
                                message:
                                    error?.msg ||
                                    error?.message ||
                                    "Unable to process the invoice. Please try again.",
                                status: "error"
                            };
                        }
                    );
            }
        } else {
            this.vesselError = true;
            this.hasError = true;
            this.loading = false;
        }

        this.modalService.dismissAll();
        //
    }

    fetchPurchaseOrg() {
        const configReq = {
            configType: "purchaseOrganizations",
            sellerCode: localStorage.getItem("vendorCode"),
            session: {
                sessionId: localStorage.getItem("userSession"),
            },
        };

        this.invoiceService.fetchConfig(configReq).subscribe(
            (res) => {
                this.configResOrg = res;
                if (
                    this.configResOrg.length !== 0 &&
                    this.configResOrg.status === "error"
                ) {
                    console.log(this.configResOrg + " Error");
                } else {
                    this.organisations = this.configResOrg.data;
                }
            },
            (error) => {
                this.hasError = true;
                this.responseData = {
                    message:
                        error?.msg ||
                        error?.message ||
                        "Unable to load configuration. Please try again.",
                    status: "error"
                };
            }
        );
    }

    fetchCompanyCode() {
        const configReq = {
            configType: "companyCodes",
            sellerCode: localStorage.getItem("vendorCode"),
            session: {
                sessionId: localStorage.getItem("userSession"),
            },
        };

        this.invoiceService.fetchConfig(configReq).subscribe(
            (res) => {
                this.configResCompanies = res;
                if (
                    this.configResCompanies.length !== 0 &&
                    this.configResCompanies.status === "error"
                ) {
                    console.log(this.configResCompanies + " Error");
                } else {
                    this.companies = this.configResCompanies.data;
                }
            },
            (error) => {
                this.hasError = true;
                this.responseData = {
                    message:
                        error?.msg ||
                        error?.message ||
                        "Unable to load configuration. Please try again.",
                    status: "error"
                };
            }
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        this.invoiceDetails = this.invoiceService.getProcessedInvoice();
        this.formSubmitted = false;

        this.fetchCompanyCode();
        this.fetchPurchaseOrg();

        if (this.invoiceDetails.doc_type === "PO2S") {
            this.isShippingInvoice = true;
        }

        this.extractedInvoiceLogistics.patchValue({
            purchaseOrg: this.invoiceDetails.purchase_org,
            docType: this.invoiceDetails.doc_type,
            //emailAddress: this.invoiceDetails.email_address.toLowerCase(),
            emailAddress: this.invoiceDetails.email_address,
            companyCode: parseInt(this.invoiceDetails.company_code),
            username: this.invoiceService.getUsername(),
            userID: this.invoiceService.getUserId(),
            poNumber: this.invoiceDetails.po_number,
        });

        this.loadFile();
    }

    closeSuccessDialog() {
        this.loading = false;
        this.router.navigateByUrl("/invoices");
    }

    closeErrorDialog() {
        this.loading = false;
        this.savingError = false;
        this.serverError = false;
    }

    resubmitInvoice() {
        this.router.navigateByUrl("/submit-nonpo-invoice");
    }

    onCheckboxChange(e: any) {
        if (e.target.checked) {
            this.extractedInvoiceLogistics.patchValue({
                terms_agreed: e.target.value,
            });
        } else {
            this.extractedInvoiceLogistics.patchValue({
                terms_agreed: null,
            });
        }
    }

    loadFile() {
        if (typeof FileReader !== "undefined") {
            let reader = new FileReader();
            reader.onload = (e: any) => {
                this.pdfSrc = e.target.result;
                //console.log(this.pdfSrc);
            };
            let $file: any = this.invoiceService.getFileElement();
            reader.readAsArrayBuffer($file);
        }

        // this.invoiceFile = new Blob([this.pdfSrc], { type: "application/pdf" });
    }

    viewSavedInvoices() {
        this.router.navigate(["/saved-invoices"]);
    }
}
